module.exports = __webpack_public_path__ + "static/img14-b2974286fdb1997fd794f3240b8acc99.jpg";